import { appWithTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { initBrowserAmplitude, trackPageView } from '@/helper/amplitudeBrowser';
import { Provider } from '../components/context';

import '../style/style.css';
import '../style/tablet.css';
import '../style/desktop.css';

import 'swiper/css';
import 'swiper/css/bundle';

const MyApp = ({ Component, pageProps }) => {
  const { asPath } = useRouter();

  useEffect(() => {
    initBrowserAmplitude();
  }, []);

  useEffect(() => {
    trackPageView();
  }, [asPath]);

  return (
    <Provider>
      <Component {...pageProps} />
    </Provider>
  );
};

export default appWithTranslation(MyApp);
